import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
} from "@material-ui/core";
import { useNavigate } from "react-router-dom";
import notEmergencyContact from "../../../assets/images/notEmergencyContact.svg";
import { useNavigationModalStyles } from "./NavigationModalStyles";

interface NavigationModalProps {
  open: boolean;
  onClose: () => void;
  path: string;
}

const NavigationModal: React.FC<NavigationModalProps> = ({
  open,
  onClose,
  path,
}) => {
  const classes = useNavigationModalStyles();
  const navigate = useNavigate();

  const handleNavigate = () => {
    onClose();
    navigate(path);
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      className={classes.dialog}
    >
      <DialogTitle is="h2">
        Ups, todavía no cargaste un contacto de emergencia
      </DialogTitle>
      <DialogContent className={classes.dialogContent}>
        <img
          src={notEmergencyContact}
          alt="imagen ilustrativa"
          className={classes.image}
        />
        <Typography variant="body1" className={classes.message}>
          Te recomendamos sumarlo desde tu perfil para estar mejor preparado
          ante cualquier imprevisto.
        </Typography>
      </DialogContent>
      <DialogActions className={classes.dialogActions}>
        <Button
          onClick={onClose}
          color="secondary"
          className={classes.acceptButton}
        >
          Aceptar
        </Button>
        <Button
          onClick={handleNavigate}
          color="primary"
          variant="contained"
          className={classes.navigateButton}
        >
          Ir a Mi Perfil
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default NavigationModal;
